export const CLEAR_ROLE_ASSUMPTION = 'CLEAR_ROLE_ASSUMPTION';
export const SAVE_ROLE_ASSUMPTED_USERNAME = 'SAVE_ROLE_ASSUMPTED_USERNAME';
export const NAVIGATE_TO_DASHBOARD = 'NAVIGATE_TO_DASHBOARD';
export const START_ROLE_ASSUMPTION = 'START_ROLE_ASSUMPTION';
export const NO_DEAL_ASSOCIATED_WITH_DEALERSHIPS = 'NO_DEAL_ASSOCIATED_WITH_DEALERSHIPS';
export const VALIDATE_ROLE_ASSUMPTION_USER_REQUEST = 'VALIDATE_ROLE_ASSUMPTION_USER_REQUEST';
export const VALIDATE_ROLE_ASSUMPTION_USER_SUCCESS = 'VALIDATE_ROLE_ASSUMPTION_USER_SUCCESS';
export const VALIDATE_ROLE_ASSUMPTION_USER_FAILURE = 'VALIDATE_ROLE_ASSUMPTION_USER_FAILURE';
export const RESET_VALIDATION_STATE = 'RESET_VALIDATION_STATE';
export const INITIALIZING_ROLE_ASSUMPTION = 'INITIALIZING_ROLE_ASSUMPTION';
